import { Container, MtLayoutTitleWrapper, SectionTitle } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import type { MtFaqPageProps } from './types';

export * from './types';

export const MtFaqPage: FC<MtFaqPageProps> = (props) => {
  const { accordionComponent, resource } = props;

  const { translate: translateResource } = useTranslation({ keyPrefix: `faq.${resource}` });

  return (
    <Container>
      <MtLayoutTitleWrapper>
        <SectionTitle>{translateResource('title')}</SectionTitle>
      </MtLayoutTitleWrapper>
      <Container>{accordionComponent}</Container>
    </Container>
  );
};
